<template>
  <v-container>
    <TableFilter
      :headers="headers"
      filterName="elevator"
      @changeFilter="filterChanged"
    />
    <v-progress-linear
      indeterminate
      :active="loader"
      color="primary"
    />
    <div class="text-right">
      <v-container>
        <v-row justify="center">
          <v-col cols="8">
            <v-container class="max-width">
              <v-pagination
                v-model="page"
                class="my-4"
                :length="length"
                :total-visible="7"
              ></v-pagination>
            </v-container>
          </v-col>
        </v-row>
      </v-container>
    </div>
    <div v-for="item in items" :key="item.id">
      <StatisticItem
        :item="item"/>
    </div>
    <v-alert
      border="bottom"
      colored-border
      type="warning"
      elevation="2"
      v-if="items.length === 0"
      class="mb-5 text-center"
    >
      {{ $t('display/elevator:statistic.no-item') }}
    </v-alert>
  </v-container>
</template>

<script>
import ElevatorHeader from '@/modules/display/views/elevator/overview/elevator-header';
import TableFilter from '@/modules/core/components/DataTable/DataTablePaginated/TableFilter';
import StatisticItem from '@/modules/display/views/elevator/budget-statistic/StatisticItem';
import BudgetStatisticService from '@/modules/display/services/budget-statistic-service';
import ElevatorService from '@/modules/display/services/elevator-service';
import Utils from '@/modules/core/services/utils';

export default {
  name: "BudgetStatistic",
  components: {
    TableFilter,
    StatisticItem
  },
  data() {
    return {
      items: [],
      filterObject: null,
      yearsOptions: [],
      monthItems: [],
      page: 1,
      length: 1,
      loader: false,
      elevatorHeader: new ElevatorHeader()
    };
  },
  watch: {
    page() {
      this.updateStatistic(this.filterObject);
    }
  },
  computed: {
    headers() {
      this.$t('');
      let header = this.elevatorHeader.getHeader();

      let monthOptions = [
        {id: 0, name: 'January', translatedName: this.$t('enums:months.january')},
        {id: 1, name: 'February', translatedName: this.$t('enums:months.february')},
        {id: 2, name: 'March', translatedName: this.$t('enums:months.march')},
        {id: 3, name: 'April', translatedName: this.$t('enums:months.april')},
        {id: 4, name: 'May', translatedName: this.$t('enums:months.may')},
        {id: 5, name: 'June', translatedName: this.$t('enums:months.june')},
        {id: 6, name: 'July', translatedName: this.$t('enums:months.july')},
        {id: 7, name: 'August', translatedName: this.$t('enums:months.august')},
        {id: 8, name: 'September', translatedName: this.$t('enums:months.september')},
        {id: 9, name: 'October', translatedName: this.$t('enums:months.october')},
        {id: 10, name: 'November', translatedName: this.$t('enums:months.november')},
        {id: 11, name: 'December', translatedName: this.$t('enums:months.december')}
      ];

      let today = new Date();

      header.push({
        text: this.$t('display/elevator:budget-statistic.month'),
        value: 'month',
        filter: {
          type: 'select',
          group: 4,
          order: 2,
          preselect: today.getMonth(),
          options: monthOptions,
          clearable: false,
          invokeFns: {
            updateModel: this.updateMonth,
          }
        },
      });
      header.push({
        text: this.$t('display/elevator:budget-statistic.year'),
        value: 'year',
        filter: {
          type: 'select',
          group: 4,
          order: 1,
          preselect: today.getFullYear(),
          options: this.yearsOptions,
          clearable: false,
          invokeFns: {
            updateModel: this.updateYear,
          }
        },
      });

      return header;
    }
  },
  methods: {
    updateStatistic(filter) {
      let sendFilter = ElevatorService.updateFilterForSend(filter);

      if (sendFilter.year === null || sendFilter.month === null) {
        let today = new Date();
        sendFilter.year = today.getFullYear();
        sendFilter.month = today.getMonth();
      }

      let paginator = {
        page: this.page - 1,
        search: '',
        size: 10,
        sort: 'createdAt',
        sortAsc: true
      };
      this.loader = true;

      BudgetStatisticService.getStatistics(
        paginator,
        sendFilter,
        (response) => {
          this.items = response.data.content;
          this.length = response.data.totalPages;
          this.loader = false;
        },
        () => {
          this.loader = false;
          Utils.showFailureSnackbar(this.$t('snackbar:load-failure', {name: this.$t('display/elevator:statistic.load-error')}));
        }
      )
    },
    updateMonth(modleValue) {
      if (modleValue == null) {
        modleValue = new Date().getMonth();
      }
      return modleValue;
    },
    updateYear(modleValue) {
      if (modleValue == null) {
        modleValue = new Date().getFullYear();
      }
      return modleValue;
    },
    checkIfExist(year) {

      for (let i = 0; i < this.yearsOptions.length; i++) {
        if (this.yearsOptions[i].id == year) {
          return true;
        }
      }

      return false;
    },
    filterChanged(filter) {
      this.filterObject = filter;
      if (this.page === 1) {
        this.updateStatistic(filter);
      } else {
        this.page = 1;
      }
    }
  },
  created() {
    let today = new Date();
    this.yearsOptions = [{id: today.getFullYear(), translatedName: today.getFullYear()}];

    BudgetStatisticService.getActiveYears(
      (response) => {
        let years = response.data;

        for (let i = 0; i < years.length; i++) {
          if (this.checkIfExist(years[i])) continue;
          this.yearsOptions.push({id: years[i], translatedName: years[i]});
        }

        this.yearsOptions.sort((a, b) => {
          return a.id - b.id;
        })
      }
    )
  },
  mounted() {
    let today = new Date();
    this.filterObject = {id: null, year: today.getFullYear(), month: today.getMonth()};
    this.updateStatistic(this.filterObject);
  }
}
</script>